import React, { useState, useEffect } from 'react';
import ImgStopsell from '../icon/stopsell.png';
import ImgCta from '../icon/cta.png';
import ImgCtd from '../icon/ctd.png';
import CellModal from './CellModal';

import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellStyle, UpdateInventoryButton, UpdateCellInput } from '../Layout';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Inventory } from '../../../../../constants/APIs';

// Redux
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

function Cell({
  propertyId,
  roomTypeId,
  rate,
  date,
  text,
  stopsell,
  cta,
  ctd,
  isEditingInventoryCell,
  currency
}) {
  const [cellText, setCellText] = useState(text || '');
  const [flipped, setFlipped] = useState(false);
  const [style, setStyle] = useState({});
  const [isVisible, setIsVisible] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (stopsell) {
      setStyle({
        backgroundImage: `url(${ImgStopsell})`,
        backgroundSize: '100% 100%',
      });
    }
    if (cta) {
      setStyle({
        backgroundImage: `url(${ImgCta})`,
        backgroundSize: '100% 100%',
      });
    }
    if (ctd) {
      setStyle({
        backgroundImage: `url(${ImgCtd})`,
        backgroundSize: '100% 100%',
      });
    }

    if (text === '-') {
      setStyle({ color: '#bdbdbd', backgroundColor: '#bdbdbd' });
      setIsVisible(false);
    }
  }, [stopsell, cta, ctd, text, isVisible]);

  const handleMouseOver = () => {
    setFlipped(true);
  };

  const handleMouseOut = () => {
    setFlipped(false);
  };

  const handleChange = e => {
    setCellText(e.target.value);
    setIsChanged(true);
  };

  const handleUpdate = () => {
    AxiosAPI({
      url: postAPI_Update_Inventory,
      method: 'post',
      data: {
        propertyId,
        data: [
          {
            roomTypeId,
            startDate: date.slice(0, 10),
            endDate: date.slice(0, 10),
            count: Number(cellText),
          },
        ],
      },
    }).then(setIsChanged(false));
  };

  const Tips = flipped => {
    if (flipped) {
      if (stopsell) return <div id="tips">stopsell</div>;
      if (cta) return <div id="tips">closed&nbsp;to&nbsp;arrival</div>;
      if (ctd) return <div id="tips">closed&nbsp;to&nbsp;departure</div>;
    }
  };

  return (
    <CellStyle
      style={style}
      onClick={
        isEditingInventoryCell
          ? null
          : () => {
            setIsVisible(true);
          }
      }
    >
      {stopsell || cta || ctd ? (
        <FontAwesomeIcon
          className="tips"
          onMouseOver={() => handleMouseOver()}
          onMouseOut={() => handleMouseOut()}
          icon={faQuestionCircle}
        />
      ) : null}
      <CellModal
        rate={rate}
        date={date}
        toggleModal={() => {
          setIsVisible(!isVisible);
        }}
        isVisible={isVisible}
        currency={currency}
      />
      {Tips(flipped)}
      {isEditingInventoryCell && isChanged && (
        <UpdateInventoryButton onClick={handleUpdate}>
          Save
        </UpdateInventoryButton>
      )}
      {isEditingInventoryCell ? (
        <UpdateCellInput
          value={cellText}
          onChange={handleChange}
        ></UpdateCellInput>
      ) : (
          <span>{text}</span>
        )}
    </CellStyle>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, currency } = settings;
  return {
    propertyId,
    currency
  };
};

export default injectIntl(connect(mapStateToProps, {})(Cell));
